const qaApiUrl =
  typeof process !== 'undefined' &&
  process.env &&
  process.env.NODE_ENV === 'development' &&
  typeof process.env.REACT_APP_API_URL === 'string' &&
  process.env.REACT_APP_API_URL.length > 0
    ? process.env.REACT_APP_API_URL.replace(/\/$/, '')
    : null;
const qaWebSocketUrl = qaApiUrl ? qaApiUrl.replace(/^http/, 'ws') : null;
const googleMyClientId =
  typeof process !== 'undefined' &&
  process.env &&
  typeof process.env.REACT_APP_GOOGLE_MY_CLIENT_ID === 'string'
    ? process.env.REACT_APP_GOOGLE_MY_CLIENT_ID
    : '';
const googleConsumerClientId =
  typeof process !== 'undefined' &&
  process.env &&
  typeof process.env.REACT_APP_GOOGLE_CONSUMER_CLIENT_ID === 'string'
    ? process.env.REACT_APP_GOOGLE_CONSUMER_CLIENT_ID
    : '';

const config = {
  development: {
    config_id: 'development',
    app_name: 'Betwixt',
    app_desc: 'Connection Needs',
    protocol: 'http',
    node_port: 3000,
    sections: {
      my: {
        port: 3030,
        hostname: 'localhost:3030',
      },
      web: {
        port: 3020,
        hostname: 'localhost:3020',
      },
      server: {
        hostname: 'localhost:8443',
      },
    },
    demo: {
      client_id: 'TYDT288HCETZ5EH6KQEU',
    },
    WebSocket: {
      uri: qaWebSocketUrl ? `${qaWebSocketUrl}/subscriptions` : 'ws://localhost:8443/subscriptions',
    },
    GraphQL: {
      uri: qaApiUrl ? `${qaApiUrl}/graphql` : 'http://localhost:8443/graphql',
    },
    stripe: {
      Publishable_key: 'pk_test_16Zue5eTtlK8Fc2bDb5HuCEA',
    },
    GTM: {
      id: 'GTM-KFW67CS',
      gtm_auth: 'pC1U8UCZgXzo3EEV7eBS9w',
      gtm_preview: 'env-3',
    },
    GA: {
      licence: 'UA-131180139-1',
    },
    google: {
      myClientId: googleMyClientId,
      consumerClientId: googleConsumerClientId,
      reCAPTCHA: '6LfBrd4tAAAAAGsQL2w0QSCnCuXg4shwSDY9TKTx',
      reCAPTCHA_v2_invisible: '6LenSpwaAAAAABzS9mHz5uzRugYPF3Zov0eAmnwU',
    },
    facebook: {
      app_id: '613188232937591',
    },
    media: {
      root: '/media',
    },
  },
  test: {
    config_id: 'test',
    protocol: 'https',
    sections: {
      my: {
        hostname: 'my.staging.betwixtpro.com',
      },
      web: {
        hostname: 'staging.betwixtpro.com',
      },
      server: {
        hostname: 'api.staging.betwixtpro.com',
      },
    },
    demo: {
      client_id: 'K33HCYVV6TLV5SPLDQXS',
    },
    WebSocket: {
      uri: 'wss://api.staging.betwixtpro.com/subscriptions',
    },
    GraphQL: {
      uri: 'https://api.staging.betwixtpro.com/graphql',
    },
    GTM: {
      gtm_auth: '_amrjXOTARAqxSnGO421Nw',
      gtm_preview: 'env-4',
    },
  },
  production: {
    config_id: 'production',
    protocol: 'https',
    sections: {
      my: {
        port: 3010,
        hostname: 'my.betwixtpro.com',
      },
      web: {
        port: 3000,
        hostname: 'www.betwixtpro.com',
      },
      server: {
        hostname: 'api.betwixtpro.com',
      },
    },
    demo: {
      client_id: 'V8XN3G3A844ZPEBGRRWR',
    },
    WebSocket: {
      uri: 'wss://api.betwixtpro.com/subscriptions',
    },
    GraphQL: {
      uri: 'https://api.betwixtpro.com/graphql',
    },
    stripe: {
      Publishable_key: 'pk_live_w2FBBOI8jcMNvEKuUgKExYF9',
    },
    GTM: {
      gtm_auth: 'vEi4erJSFn85OGdYOVab3Q',
      gtm_preview: 'env-1',
    },
    facebook: {
      app_id: '1160812507630941',
    },
  },
};

export default config;
